import { DynamicContentType } from '@bm-js/atlascloud-shared'
import { CLink, LinkComponentType } from './CLink'
import { LogoSectionData } from '@bm-js/atlascloud-shared'
import { useMargin } from '../utils/hooks'
import { ResponsiveImage } from './ResponsiveImage'

type Props = {
  content: DynamicContentType<LogoSectionData>
  LinkComponent: LinkComponentType
}

export const LogoSection = ({ content, LinkComponent }: Props) => {
  const margins = useMargin(content)

  return (
    <div className='@container'>
      <div
        className={`flex flex-col gap-8 items-center @3xl:flex-row @3xl:justify-around ${margins}`}
      >
        {content.data.logos.map((logo, i) => (
          <CLink
            key={`logoSection_${content.uuid}_${i}`}
            href={logo.link || '#'}
            LinkComponent={LinkComponent}
            className='w-full max-w-[200px]'
          >
            <ResponsiveImage
              className='w-full'
              file={logo.image}
              title={logo.name}
              alt={logo.name}
            />
          </CLink>
        ))}
      </div>
    </div>
  )
}
